import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchPaymentType_api = async () => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Payments/fetch_payment_type.php`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Fetch payment type failed:", error);
    return { error: "Fetch payment type failed" };
  }
};
